import { render, staticRenderFns } from "./CasosActivosSinCobradorLiquidadorEjecutivo.vue?vue&type=template&id=36b7fb7b&"
import script from "./CasosActivosSinCobradorLiquidadorEjecutivo.vue?vue&type=script&lang=js&"
export * from "./CasosActivosSinCobradorLiquidadorEjecutivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports